
document.addEventListener('DOMContentLoaded', function () {
    const scrollableCard = document.querySelector(".comparison-grid");
    const scrollIndicatorContainer = document.querySelector(".scroll-indicator");
    const scrollIndicator = document.querySelector(".scroll-indicator-inner");
    const featureCards = scrollableCard.querySelectorAll(".comparison-card");

    const CARD_WIDTH = featureCards[0].offsetWidth;
    const INDICATOR_WIDTH = scrollIndicatorContainer.offsetWidth;
    const INDICATOR_MOVING_WIDTH = scrollIndicator.offsetWidth;
    let travelDist = INDICATOR_WIDTH - INDICATOR_MOVING_WIDTH;
    let progress = 0;

    let ticking = false; // throttle flag

    scrollableCard.addEventListener('scroll', () => {
        if (!ticking) {
            window.requestAnimationFrame(() => {
                let scrollLeft = scrollableCard.scrollLeft;
                progress = scrollLeft / CARD_WIDTH;
                let indicatorPos = progress * travelDist;
                scrollIndicator.style.transform = `translateX(${indicatorPos}px)`;
                ticking = false;
            });
            ticking = true;
        }
    });
});
